// @flow

export const LAYOUT_1X2 = '1x2'
export const LAYOUT_1X3 = '1x3'
export const LAYOUT_1X4 = '1x4'
export const LAYOUT_2X2 = '2x2'
export const LAYOUT_2PLUS1 = '2+1'
export const LAYOUT_1PLUS2 = '1+2'
export const LAYOUT_MASONRY = 'masonry'
export const LAYOUT_CUSTOM = 'custom'

export const LAYOUT_OPTIONS = [
  { label: '1x2', value: LAYOUT_1X2 },
  { label: '1x3', value: LAYOUT_1X3 },
  { label: '1x4', value: LAYOUT_1X4 },
  { label: '2x2', value: LAYOUT_2X2 },
  { label: '2+1', value: LAYOUT_2PLUS1 },
  { label: '1+2', value: LAYOUT_1PLUS2 },
  { label: 'Masonry', value: LAYOUT_MASONRY },
  // TODO: Temporarily disabled layout as it is not fully implemented yet
  // { label: 'Custom', value: LAYOUT_CUSTOM },
]

export type LayoutSetting =
  | typeof LAYOUT_1X2
  | typeof LAYOUT_1X3
  | typeof LAYOUT_1X4
  | typeof LAYOUT_2X2
  | typeof LAYOUT_2PLUS1
  | typeof LAYOUT_1PLUS2
  | typeof LAYOUT_MASONRY
  | typeof LAYOUT_CUSTOM

export const LAYOUT_NUMBER_OF_COLUMNS: Record<LayoutSetting, number> = {
  [LAYOUT_1X2]: 2,
  [LAYOUT_1X3]: 3,
  [LAYOUT_1X4]: 4,
  [LAYOUT_2X2]: 2,
  [LAYOUT_2PLUS1]: 2,
  [LAYOUT_1PLUS2]: 2,
  [LAYOUT_MASONRY]: 3,
  [LAYOUT_CUSTOM]: 0,
}

export const LAYOUT_NUMBER_OF_ROWS: Record<LayoutSetting, number> = {
  [LAYOUT_1X2]: 1,
  [LAYOUT_1X3]: 1,
  [LAYOUT_1X4]: 1,
  [LAYOUT_2X2]: 2,
  [LAYOUT_2PLUS1]: 2,
  [LAYOUT_1PLUS2]: 2,
  [LAYOUT_MASONRY]: 2,
  [LAYOUT_CUSTOM]: 0,
}

export const LAYOUT_PREVIEW_NUMBER_OF_CELLS: Record<LayoutSetting, number> = {
  [LAYOUT_1X2]: 2,
  [LAYOUT_1X3]: 3,
  [LAYOUT_1X4]: 4,
  [LAYOUT_2X2]: 4,
  [LAYOUT_2PLUS1]: 3,
  [LAYOUT_1PLUS2]: 3,
  [LAYOUT_MASONRY]: 4,
  [LAYOUT_CUSTOM]: 0,
}

export type ColumnWidthSettingItem = {
  mode: 'dynamic' | 'fixed',
  dynamic_value: number,
  fixed_value: number,
}

export type RowHeightSettingItem = {
  mode: 'auto' | 'fixed',
  fixed_value: number,
}
